import { config } from './fragments.config';

export const WHITE = config.colors.white;

export const GREY_100 = config.colors['grey-100'];
export const GREY_200 = config.colors['grey-200'];
export const GREY_300 = config.colors['grey-300'];
export const GREY_400 = config.colors['grey-400'];
export const GREY_500 = config.colors['grey-500'];
export const GREY_600 = config.colors['grey-600'];
export const GREY_700 = config.colors['grey-700'];
export const GREY_800 = config.colors['grey-800'];
export const GREY_900 = config.colors['grey-900'];

export const ORANGE_100 = config.colors['orange-100'];
export const ORANGE_200 = config.colors['orange-200'];
export const ORANGE_300 = config.colors['orange-300'];
export const ORANGE_400 = config.colors['orange-400'];
export const ORANGE_500 = config.colors['orange-500'];
export const ORANGE_600 = config.colors['orange-600'];
export const ORANGE_700 = config.colors['orange-700'];
export const ORANGE_800 = config.colors['orange-800'];
export const ORANGE_900 = config.colors['orange-900'];

export const NEBULA_100 = config.colors['nebula-100'];
export const NEBULA_200 = config.colors['nebula-200'];
export const NEBULA_300 = config.colors['nebula-300'];
export const NEBULA_400 = config.colors['nebula-400'];
export const NEBULA_500 = config.colors['nebula-500'];
export const NEBULA_600 = config.colors['nebula-600'];
export const NEBULA_700 = config.colors['nebula-700'];
export const NEBULA_800 = config.colors['nebula-800'];
export const NEBULA_900 = config.colors['nebula-900'];

export const PINK_100 = config.colors['pink-100'];
export const PINK_200 = config.colors['pink-200'];
export const PINK_300 = config.colors['pink-300'];
export const PINK_400 = config.colors['pink-400'];
export const PINK_500 = config.colors['pink-500'];
export const PINK_600 = config.colors['pink-600'];
export const PINK_700 = config.colors['pink-700'];
export const PINK_800 = config.colors['pink-800'];
export const PINK_900 = config.colors['pink-900'];

export const RED_100 = config.colors['red-100'];
export const RED_200 = config.colors['red-200'];
export const RED_300 = config.colors['red-300'];
export const RED_400 = config.colors['red-400'];
export const RED_500 = config.colors['red-500'];
export const RED_600 = config.colors['red-600'];
export const RED_700 = config.colors['red-700'];
export const RED_800 = config.colors['red-800'];
export const RED_900 = config.colors['red-900'];

export const CYAN_100 = config.colors['cyan-100'];
export const CYAN_200 = config.colors['cyan-200'];
export const CYAN_300 = config.colors['cyan-300'];
export const CYAN_400 = config.colors['cyan-400'];
export const CYAN_500 = config.colors['cyan-500'];
export const CYAN_600 = config.colors['cyan-600'];
export const CYAN_700 = config.colors['cyan-700'];
export const CYAN_800 = config.colors['cyan-800'];
export const CYAN_900 = config.colors['cyan-900'];

export const GREEN_100 = config.colors['green-100'];
export const GREEN_200 = config.colors['green-200'];
export const GREEN_300 = config.colors['green-300'];
export const GREEN_400 = config.colors['green-400'];
export const GREEN_500 = config.colors['green-500'];
export const GREEN_600 = config.colors['green-600'];
export const GREEN_700 = config.colors['green-700'];
export const GREEN_800 = config.colors['green-800'];
export const GREEN_900 = config.colors['green-900'];

export const COLOR_SEARCH = config.colors.search;
export const COLOR_ANSWERS = config.colors.answers;
export const COLOR_RECOMMEND = config.colors.recommend;
